import { Flex, Text } from '@chakra-ui/react';
import { ReactComponent as PlayersIcon } from '../../assets/icons/PlayersIcon.svg';

interface GameCountProps {
    gamesCount: number;
    playersCount: number;
}

export const GameStatCounts: React.FC<GameCountProps> = ({ gamesCount, playersCount }) => {
    return (
        <Flex className={'game-info-counts'}>
            <Flex className={'stats-count'}>
                <PlayersIcon />
                <Text>{gamesCount}</Text>
            </Flex>
            <Flex className={'stats-count'}>
                <Text className={'stats-players'}>1UP</Text>
                <Text>{playersCount}</Text>
            </Flex>
        </Flex>
    );
};
